<div class="main-container"
     [ngClass]="{'min-height': !!inLoading && !fullPage}">
  <div *ngIf="!!inLoading"
       [id]="loaderId"
       class="overlay"
       [ngClass]="{'loader-content': fullPage || withContent, 'loader-full-page': fullPage}">
    <div class="loader">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
  <ng-content></ng-content>
</div>
